// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-name-index-module__container-XfACCV {
  flex-direction: column;
  flex: 1;
  align-self: stretch;
  display: flex;
  position: relative;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-name-index-module__container-XfACCV.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-name-index-module__withDescription-D5xapX {
  flex: none;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-name-index-module__container-XfACCV .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-name-index-module__name-ZIYxKM {
  align-self: stretch;
  align-items: flex-start;
  width: 100%;
  display: flex;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-name-index-module__container-XfACCV .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-name-index-module__name-ZIYxKM > div:first-child {
  flex: 1;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-name-index-module__container-XfACCV`,
	"withDescription": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-name-index-module__withDescription-D5xapX`,
	"name": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-name-index-module__name-ZIYxKM`
};
export default ___CSS_LOADER_EXPORT___;
